import {React, styled} from 'common'
import {Badge, IconButton, Toolbar, Tooltip, Typography, alpha} from '@mui/material'
import DeleteIcon from '@mui/icons-material/Delete'
import FilterListIcon from '@mui/icons-material/FilterList'
import AddRoundedIcon from '@mui/icons-material/AddRounded'
import {useRef, useState} from 'react'
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined'
import {useTranslation} from 'react-i18next'
import Filters from './Filters'
import {useUrlParams} from 'services/hooks'
import Loader from '../Loader/Loader'
import useResponsive from 'logic/useResponsive'

const TableHeader = ({
    tableName,
    numSelected,
    filters,
    filterKeys,
    isLoadingFilters,
    onOpenFilters,
    setOpenAddDialog,
    tooltipErrorMessage,
    isLoading,
    allowCreate,
    costumeActions,
}) => {
    const {urlParams} = useUrlParams()
    const [openFilters, setOpenFilters] = useState(false)
    const anchorRef = useRef(null)
    const {smallScreen, mediumScreen, largeScreen} = useResponsive()
    const filerKey = filterKeys || []
    const urlKey = Object.keys(urlParams)
    const isFilter = urlKey?.some((key) => filerKey?.includes(key))

    const {t} = useTranslation()
    return (
        <Toolbar
            sx={{
                pl: {sm: 2},
                pr: {xs: 1, sm: 1},
                ...(numSelected > 0 && {
                    bgcolor: (theme) =>
                        alpha(theme.palette.primary.main, theme.palette.action.activatedOpacity),
                }),
            }}>
            <Typography sx={{flex: '1 1 100%'}} variant="h6" id="tableTitle" component="div">
                {t(`side_menu.${tableName}`)}
            </Typography>
            <Loader show={isLoading} />
            {numSelected > 0 && (
                <Typography
                    sx={{flex: '1 1 100%'}}
                    color="inherit"
                    variant="subtitle1"
                    component="div">
                    {numSelected} selected
                </Typography>
            )}

            {tooltipErrorMessage && (
                <TooltipError title={tooltipErrorMessage}>
                    <IconButton>
                        <ErrorIcon />
                    </IconButton>
                </TooltipError>
            )}
            {costumeActions &&
                costumeActions.map((action, index) => {
                    const {
                        ActionComponent,
                        showOn = ['small', 'medium', 'large'],
                        ...restProps
                    } = action || {}
                    const shouldShow =
                        (showOn.includes('small') && smallScreen) ||
                        (showOn.includes('medium') && mediumScreen) ||
                        (showOn.includes('large') && largeScreen)
                    if (!shouldShow) return null
                    return <ActionComponent key={index} {...restProps} />
                })}
            {allowCreate && (
                <Tooltip title={t('table.header.add')}>
                    <IconButton onClick={() => setOpenAddDialog(null)}>
                        <AddRoundedIcon />
                    </IconButton>
                </Tooltip>
            )}

            {numSelected > 0 && (
                <Tooltip title={'Delete'}>
                    <IconButton>
                        <DeleteIcon />
                    </IconButton>
                </Tooltip>
            )}

            {filerKey.length > 0 && (
                <>
                    <Tooltip title={t('table.header.filter')}>
                        <IconButton
                            onClick={() => {
                                onOpenFilters?.()
                                setOpenFilters(true)
                            }}
                            ref={anchorRef}>
                            <Badge invisible={!isFilter} color="primary" variant="dot">
                                <FilterListIcon />
                            </Badge>
                        </IconButton>
                    </Tooltip>

                    <Filters
                        open={openFilters}
                        onClose={setOpenFilters}
                        anchorEl={anchorRef.current}
                        filters={filters}
                        isLoading={isLoadingFilters}
                    />
                </>
            )}
        </Toolbar>
    )
}

export default TableHeader

const TooltipError = styled(Tooltip)``

const ErrorIcon = styled(ErrorOutlineOutlinedIcon)`
    color: red;
`
